module.exports = __webpack_public_path__ + "static/media/charges.6e85993f.svg";